import { render } from "./Resizer.vue?vue&type=template&id=89311792"
import script from "./Resizer.vue?vue&type=script&lang=js"
export * from "./Resizer.vue?vue&type=script&lang=js"

import "./Resizer.vue?vue&type=style&index=0&id=89311792&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__